import { writable } from 'svelte/store'
import { createRouteStore } from 'svelte-store-router'

export const route = createRouteStore({
  delay: 300,
  queryClean: true,
  fragmentClean: true
})

export const CustomerStore = writable([])
export const CheeseTypeStore = writable([])
export const LocationStore = writable([])

export const Authentication = writable(null)

export const modal = writable(null);